const Badge = ({ 
  label,        // optional shortcut for text-only badges
  color = "primary", 
  pill = true,
  children      // allows JSX inside
}) => {
  return (
    <span 
      className={`
        badge bg-${color} 
        ${pill ? "rounded-pill" : ""}
        px-2 py-1
        px-md-4 py-md-2
        fs-12
        mb-0
      `}
    >
      {children || label}
    </span>
  );
};

export default Badge;